import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'

interface ConfirmationModalState {
  display: boolean,
  type: string,
  name: string,
  callback: VoidFunction
}

interface Props {
  confirmationModalState: ConfirmationModalState
  closeCallback: VoidFunction
}

const ConfirmationModal: FC<Props> = (props) => {
  const { t } = useTranslation()

  const {
    login,
  } = useSelector((state: RootState) => state)

  const {
    confirmationModalState,
    closeCallback,
  } = props

  const [scrollY, setScrollY] = useState<number>(0)

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (confirmationModalState.display) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [confirmationModalState.display])

  return (
    <>
      {
        confirmationModalState.display && (
          <div className="modal_wrap">
            <div className={`confirmation_modal ${confirmationModalState.display || 'none'}`} style={{ width: "500px" }}>
              <div className="confirmation_modal_header">
                <div className="title">
                  {
                    confirmationModalState.type === "delegation"
                      ? t('setting.admin.delegation_modal.title')
                      : t('setting.admin.delete_modal.title')
                  }
                </div>
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="confirmation_modal_body">
                {
                  confirmationModalState.type === "delegation" ? (
                    <>
                      <p>
                        {t('setting.admin.delegation_modal.member_header')}
                        &nbsp;
                        <span id="delete-member-name">{confirmationModalState.name}</span>
                      </p>
                      <p>
                        {t('setting.admin.delegation_modal.confirm')}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>
                        {t('setting.admin.delete_modal.member_header')}
                        &nbsp;
                        <span id="delete-member-name">{confirmationModalState.name}</span>
                      </p>
                      <p>
                        {t('setting.admin.delete_modal.confirm')}
                      </p>
                      {
                        login.function_enabled_state?.task_management && (
                          <p
                            style={{
                              color: "#FF0000",
                            }}
                          >
                            ※ 工数管理のプロジェクト設定権限は削除されません。
                          </p>
                        )
                      }
                    </>
                  )
                }
              </div>
              <div className="confirmation_modal_footer">
                <button type="button" className="button cancel" onClick={closeCallback}>
                  {t('form.component.cancel')}
                </button>
                <button
                  type="button"
                  className={`button ${confirmationModalState.type}`}
                  onClick={() => {
                    confirmationModalState.callback()
                    closeCallback()
                  }}
                >
                  {
                    confirmationModalState.type === "delegation"
                      ? t('setting.admin.delegation_modal.button')
                      : t('form.component.delete')
                  }
                </button>
              </div>
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeCallback} />
          </div>
        )
      }
    </>
  )
}

export default ConfirmationModal
